import { createAction, props } from '@ngrx/store';

export const resetMessageState = createAction('[Message] Reset message state');

export const setChannel = createAction(
  '[Message] Set channel for chat page',
  props<{ channel: string }>(),
);
